import { 
    gql, 
    useMutation, 
    ApolloError,
    MutationTuple  
} from "@apollo/client";
import { 
    MarkNjoyCodeAsUsedMutationMutation, 
    MarkNjoyCodeAsUsedMutationMutationVariables
} from "../../../../schemaTypes";

export const markNjoyCodeAsUsedMutation = gql`
  mutation MarkNjoyCodeAsUsedMutation(
        $adminId: String!
        $njoyCode: String!
    ) {
    markNjoyCodeAsUsed(
        adminId: $adminId
        njoyCode: $njoyCode
    ) {
      errors {
        path
        message
      }
      message
      njoyCode
    }
  }
`;

export const MarkNjoyCodeAsUsedController: React.FC<{ children: (data: {
  markNjoyCodeAsUsed: MutationTuple<
  MarkNjoyCodeAsUsedMutationMutation, 
  MarkNjoyCodeAsUsedMutationMutationVariables
  >[0];
  loading: boolean;
  error?: ApolloError;
  data?: MarkNjoyCodeAsUsedMutationMutation;
  errors?: { path: string; message: string }[] | null;
  message?: string | null;
  njoyCode?: string | null;
}) => React.ReactElement | null }> = ({ children }) => {
  const [markNjoyCodeAsUsed, { loading, error, data }] = useMutation<
  MarkNjoyCodeAsUsedMutationMutation, 
  MarkNjoyCodeAsUsedMutationMutationVariables
  >(markNjoyCodeAsUsedMutation);

  // Extract errors and message from the mutation result, matching resolver response
  const errorsRaw = data?.markNjoyCodeAsUsed?.errors ?? null;
  const errors = Array.isArray(errorsRaw)
    ? errorsRaw.filter((e): e is { path: string; message: string } => !!e)
    : errorsRaw;
  const message = data?.markNjoyCodeAsUsed?.message ?? null;
  const njoyCode = data?.markNjoyCodeAsUsed?.njoyCode ?? null;

  return children({
    markNjoyCodeAsUsed,
    loading,
    error,
    data: data ?? undefined,
    errors,
    message,
    njoyCode
  });
};